import { Link } from "gatsby"
import React from "react"
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

/* importing icons */
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';

/* importing image file */
import logo from '../images/logo.png';
import xIcon from '../images/social/x_icon.png';

const useStyles = makeStyles((theme) => ({
    mainContainer:{
        backgroundColor:'#003a4d',
        padding: '40px 0',
        justifyContent: 'center'
    },
    footerLogo:{
        height:130
    },
    footerNavLinks:{
        fontSize:16,
        textDecoration: 'none !important',
        listStyleType:'none',
        cursor: 'pointer !important',
        '&':{
            color:'#ffffff',
        },
        '& :hover':{
            color: '#f7941e',
        }
    },    
    footerNavLinksHeader:{
        fontSize:16,
        color:'#ffffff',
        textDecoration: 'none',
        paddingLeft:'20px',
        marginBottom:10
    },
    socialMediaIcons:{
        fontSize:25,
        color:'#ffffff',
        cursor: 'pointer'
  },
    socialMediaContainer:{
        display: 'flex',
        alignItems: 'center'
  },
    socialMediaLink:{
        width: 25,
        height: 25,
        marginRight: 30,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
  },
    socialMediaXIcon:{
        width: 21,
        height: 21,
        objectFit: 'contain',
        display: 'block',
        marginBottom: 0,
        marginTop: 0
  },
    copyRightContainer:{
        color: '#ffffff',
        fontSize:13,
        background: '#f7941e',
        textAlign: 'center',
        padding: '20px 22px',
        width:'100%'
  },
    footerLogoContainer:{
        paddingLeft: 32,
        marginBottom: 20
    }
}));

const row2=[
    {"id":"1", "linkName":"Career Counselling", "type":"NavLink", "associatedLink":"/career-counselling"},
    {"id":"2", "linkName":"Adolescent Counselling", "type":"NavLink", "associatedLink":"/adolescent-specific-services"},
    {"id":"3", "linkName":"Counselling & Psychotherapy", "type":"NavLink", "associatedLink":"/counselling-and-psychotherapy"},
    {"id":"4", "linkName":"Relationship & Family Counselling", "type":"NavLink", "associatedLink":"/relationship-family-counselling"},
    {"id":"5", "linkName":"Training & Workshop", "type":"NavLink", "associatedLink":"/training-workshop"}
];

const row3=[
    {"id":"1", "linkName":"About us", "type":"NavLink", "associatedLink":"/about-us"},
    {"id":"2", "linkName":"Blog", "type":"NavLink", "associatedLink":"/blog"},
    {"id":"3", "linkName":"Contact us", "type":"NavLink", "associatedLink":"/contact-us"}
];


export default function Footer (){
    const classes = useStyles();
    return(
    <>
    <Grid container className={classes.mainContainer}>
        
        <Grid item xs={12} sm={12} md={4} className={classes.footerLogoContainer}>
            <div>
            <img src={logo} alt="logo" className={classes.footerLogo}/>
            <div className={classes.socialMediaContainer}>
                <a href="https://www.facebook.com/Pratiiti/" target="_blank" rel="noopener noreferrer" className={classes.socialMediaLink}><FacebookIcon className={classes.socialMediaIcons}/></a>
                <a href="https://twitter.com/pratiiti1/" target="_blank" rel="noopener noreferrer" aria-label="Pratiiti on X" className={classes.socialMediaLink}><img src={xIcon} alt="X" className={classes.socialMediaXIcon} /></a>
                <a href="https://www.instagram.com/pratiiti_luminaries/" target="_blank" rel="noopener noreferrer" className={classes.socialMediaLink}><InstagramIcon className={classes.socialMediaIcons}/></a>
                <a href="https://www.linkedin.com/in/pratiiti-luminaries-6443341aa/" target="_blank" rel="noopener noreferrer" className={classes.socialMediaLink}><LinkedInIcon className={classes.socialMediaIcons}/></a>
            </div>
            </div>
        </Grid>
        
        <Grid item xs={12} sm={12} md={4}>
            <div className={classes.footerNavLinksHeader}>{"Our Services"}</div>
            <ul>
            {
                row2.map((index)=>{
                    return(<li className={classes.footerNavLinks}><Link className={classes.footerNavLinks} to={index["associatedLink"]}>{index["linkName"]}</Link></li>)
                })   
            }
            </ul>
        </Grid>

        <Grid item xs={12} sm={12} md={4}>
            <ul>
            {
                row3.map((index)=>{
                    return(<li className={classes.footerNavLinks}><Link className={classes.footerNavLinks} to={index["associatedLink"]}>{index["linkName"]}</Link></li>)
                })   
            }
            </ul>
        </Grid>
    </Grid>
    <Grid container> 
        <Grid className={classes.copyRightContainer} xs={12} sm={12} md={12}>
            Copyright © 2013 - 2026 Pratiiti. All Rights Reserved.
        </Grid>
    </Grid>
    </>
    )
}
